var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-red"},[_c('div',{staticClass:"red-img"}),_c('p',{staticClass:"count-down"},[_vm._v(" "+_vm._s(_vm.realCountdown)+"S关闭 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }